module.exports = __webpack_public_path__ + "img/still (39).67b78674.jpg";